export const APP_ENVIRONMENT_MODES = {
  LOCAL: 'development',
  TEST: 'test',
  UAT: 'uat',
  UAT2: 'uat2',
  PROD: 'prod',
}

export function getAppEnvironmentModeFlags(mode = import.meta.env.MODE) {
  const normalizedMode = String(mode || '').toLowerCase()
  const isLocalMode = normalizedMode === 'development' || normalizedMode === 'local'
  const isUat2Mode = normalizedMode === 'uat2'

  return {
    mode: normalizedMode,
    isLocalMode,
    isTestMode: normalizedMode === APP_ENVIRONMENT_MODES.TEST,
    isUatMode: normalizedMode === APP_ENVIRONMENT_MODES.UAT,
    isUat2Mode,
    isProdMode: normalizedMode === APP_ENVIRONMENT_MODES.PROD,
    canShowLocalOrUat2Features: isLocalMode || isUat2Mode,
  }
}

export function useAppEnvironmentMode() {
  return getAppEnvironmentModeFlags()
}
